import { render, staticRenderFns } from "./EModalVisualizarEvento.vue?vue&type=template&id=2afcbf43&scoped=true"
import script from "./EModalVisualizarEvento.vue?vue&type=script&lang=js"
export * from "./EModalVisualizarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcbf43",
  null
  
)

export default component.exports